import React from 'react'
import Layout from './Layout'
import { useProps } from './useProps'

export const Coupon = (params: { couponId: App.Coupon['id'] }) => <Layout {...useProps(params)} />
